import { create } from 'zustand';
import { ApiUtils, MessageItemEntity, MessagesApi, RequestStrategyEnum } from '@shared/api';

interface IThreadStore {
  loading: boolean;
  error: string | null;
  thread: MessageItemEntity[];
  getThread: (threadId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useThreadStore = create<IThreadStore>((set) => ({
  loading: false,
  error: null,
  thread: [],

  getThread: ApiUtils.wrapperApi(async (threadId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await MessagesApi.getThread(threadId, signal);
      set({ thread: result.data ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Default),

  clear: () => set({ thread: [], loading: false, error: null }),
}));
